import type {
  EnhancedSensorEntry,
  TimeSeriesDerivedValueEntryJSON,
} from 'types'

export type LegendUnitSources = {
  derivedValues: TimeSeriesDerivedValueEntryJSON[]
  sensorRanges: Record<string, { min?: number; max?: number; unit: string }>
  enhancedSensorEntries: EnhancedSensorEntry[]
}

const usableUnit = (unit: unknown): string | null =>
  typeof unit === 'string' && unit && unit !== 'No Unit' ? unit : null

export type HoverUnitSources = {
  derivedValues: TimeSeriesDerivedValueEntryJSON[]
  unitMapping: Record<string, string>
}

/** Unit shown next to a hovered value: the pen's own unit for derived and computed pens, the sensor unit map otherwise. */
export function hoverUnit(
  { id, name }: { id: string; name: string },
  { derivedValues, unitMapping }: HoverUnitSources
): string | null {
  return (
    usableUnit(derivedValues.find((d) => d.id === id)?.data.unit) ??
    usableUnit(unitMapping[name])
  )
}

export function legendLabel(
  { id, name }: { id: string; name: string },
  { derivedValues, sensorRanges, enhancedSensorEntries }: LegendUnitSources
): string {
  const unit = id.startsWith('derived_')
    ? usableUnit(derivedValues.find((d) => d.id === id)?.data.unit)
    : (usableUnit(sensorRanges[id]?.unit) ??
      usableUnit(enhancedSensorEntries.find((e) => e.id === id)?.data?.unit))
  return unit ? `${name} (${unit})` : name
}
